export default class CenterOfHopeDetailDto {
  constructor(options = {}) {
    this.clientBarrierNew = options.clientBarrierNew || [];
    this.clientBarrierRemoved = options.clientBarrierRemoved || [];
    this.clientGoalNew = options.clientGoalNew || [];
    this.clientGoalRemoved = options.clientGoalRemoved || [];
  }

  stringify() {
    return JSON.stringify(this);
  }
}
